/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiProjectsIdQueryResponse,
  GetApiProjectsIdPathParams,
} from '../models/GetApiProjectsId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiProjectsIdQueryResponseSchema } from '../zod/getApiProjectsIdSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiProjectsIdQueryKey = (
  id: GetApiProjectsIdPathParams['id'],
) => [{ url: '/api/projects/:id', params: { id: id } }] as const;

export type GetApiProjectsIdQueryKey = ReturnType<
  typeof getApiProjectsIdQueryKey
>;

/**
 * {@link /api/projects/:id}
 */
export async function getApiProjectsId(
  id: GetApiProjectsIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: `/api/projects/${id}`, ...requestConfig });
  return getApiProjectsIdQueryResponseSchema.parse(res.data);
}

export function getApiProjectsIdQueryOptions(
  id: GetApiProjectsIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsIdQueryKey(id);
  return queryOptions<
    GetApiProjectsIdQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiProjectsIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsId(id, config);
    },
  });
}

/**
 * {@link /api/projects/:id}
 */
export function useGetApiProjectsId<
  TData = GetApiProjectsIdQueryResponse,
  TQueryData = GetApiProjectsIdQueryResponse,
  TQueryKey extends QueryKey = GetApiProjectsIdQueryKey,
>(
  id: GetApiProjectsIdPathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsIdQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiProjectsIdQueryKey(id);

  const query = useQuery(
    {
      ...getApiProjectsIdQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
